module.exports = __webpack_public_path__ + "static/media/25a.fb695aad.jpg";